import { booleanAttribute, ChangeDetectorRef, Component, HostListener, OnInit } from '@angular/core';
import { DirectorioContactosService } from '../../services/directorio-contactos.service';
import { Estado } from '../../models/InmuebleSearch.model.response';
import { Modal } from 'bootstrap';
import Swal from 'sweetalert2';
import {  SolicitudGerente } from 'src/app/models/solicitudGerente';
import { InmuebleResponse } from 'src/app/models/InmueblesResponse';
import { FormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { OpExitosaModalComponent } from '../op-exitosa-modal/op-exitosa-modal.component';

@Component({
  selector: 'app-directorio-contacto',
  templateUrl: './directorio-contacto.component.html',
  styleUrls: ['./directorio-contacto.component.css'],
  standalone: false
})
export class DirectorioContactoComponent implements OnInit {

  [x: string]: any;

  // Propiedades principales
  payLoadOportunidad:  SolicitudGerente = new SolicitudGerente();
  contacto: SolicitudGerente;
  contactos: any[] = [];
  mensajeError = 'Cargando...';
  paginador: any;
  noPagina: number[] = [];
  estados: Estado[] = [];
  estadosSeleccionados: number[] = [0];
  estadosSeleccionadosNombres: Estado[] = [];
  contactosFiltrados: any[] = [];
  solicitudgerente: SolicitudGerente = new SolicitudGerente();
  OK: string = 'OK';
  idG: number = 0;
  correo?: string;
  estado?: string;
  informacion?: string;
  mensaje?: string;
  nombre?: string;
  telcel?: string;
  telfijo?: string;
  folio?: string;
  public enviado = false;
  
  // Formularios
  formSolicitudGen: UntypedFormGroup;
  
  // Estado de la aplicación
  requestDirectorio = {
    page: 0,
    estados: [0],
    filas: 5
  };
  a = false;

  yaSeBuscoEstado = false;
  estadoSeleccionado: number = 0;

  // Ordenamiento
  campoOrden = '';
  ordenAscendente = true;

  mostrarEmptyState: boolean = true;
  mostrarSinResultados: boolean = false;
  mostrarSpinner: boolean = false;
  filasSeleccionadas: number = 5;
  opcionesFilas: number[] = [];
  totalFilas: number = 0;
  desdeFila: number = 0;
  hastaFila: number = 0;

  constructor(
    private directorioService: DirectorioContactosService,
    private dialog: MatDialog,
    private cdRef: ChangeDetectorRef,
    private fb: FormBuilder
  ) {}

  ngOnInit() {
    this.initForm();
    this.obtenerEstados();
  }
  
  private initForm() {
    this.formSolicitudGen = this.fb.group({
      buscoinformacion: ['', Validators.required],
      folio: ['', [Validators.required, Validators.pattern('^[0-9]{5}$')]],
      nombre: ['', [Validators.required, this.nombreValido()]],
      paterno: ['', [Validators.required, this.nombreValido()]],
      materno: ['', this.nombreValido()],
      correo: ['', [Validators.required, Validators.email]],
      telefonocelular: ['', [Validators.required, this.telefonoValido()]],
      telefonofijo: ['', this.telefonoValido()],
      mensaje: ['', [Validators.maxLength(100)]],
      todos: ['', Validators.required]
    });
  }

  get isFormValid(): boolean {

    return this.formSolicitudGen.valid;
  }

  reiniciarFormulario() {
    this.initForm();
    this.cdRef.detectChanges();
  }

  private telefonoValido() {
    return (control: UntypedFormControl): { [key: string]: any } | null => {
      const valor: string = control.value;
      if (!valor) {
        return null;
      }

      const diezDigitos = /^\d{10}$/;

      const repetidos5 = /(.)\1{5,}/;

      if (repetidos5.test(valor)) {
        return { repetidos5: true };
      }

      if (!diezDigitos.test(valor)) {
        return { telefonoInvalido: true };
      }

      return null;
    };
  }

  private nombreValido() {
    return (control: UntypedFormControl): { [key: string]: any } | null => {
      const valor: string = (control.value || '').trim();

      if (!valor) {
        return null;
      }

      if (valor.length < 2 || valor.length > 50) {
        return { longitud: true };
      }

      if (valor.length === 2 && valor[0].toLowerCase() === valor[1].toLowerCase()) {
        return { repetidos: true };
      }

      return null;
    };
  }

  obtenerEstados() {
    this.directorioService.getEstados().subscribe(data => {
      //console.log(data);
      this.estados = data;
    }, err => {
      this.estados = [];
    })
  }

  crearPaginas(totalPaginas: number) {
    this.noPagina = [];
    for (let i = 0; i < totalPaginas; i++) {
      this.noPagina.push(i);
    }
  } 

  cambiarDePagina(request) {
    this.mensajeError = "Cargando...";
    const totalReg = this.filasSeleccionadas;

    this.directorioService.getAllContactos(request, totalReg).subscribe(data => {
      if (data.content) {
        this.asignarData(data);
      }
    }, error => {
      this.mensajeError = "Error al cargar la información.";
    });

    this.a = true;
  }

  prepararRequest(page: number) {
    this.requestDirectorio.page = page;
    this.requestDirectorio.estados = this.estadosSeleccionados;
    this.requestDirectorio.filas = this.filasSeleccionadas;
    this.cambiarDePagina(this.requestDirectorio);
  }

  listarEstados(idEsado: number) {
    if (idEsado == 0) {
      this.estadosSeleccionados = [0];
      this.estadosSeleccionadosNombres = [];
      return;
    }
    this.estadosSeleccionados = this.estadosSeleccionados.filter(this.diferenteDeCero);
    let estaSeleccionado = false;
    this.estadosSeleccionados.forEach(e => {
      if (e == idEsado)
        estaSeleccionado = true;
    })
    if (!estaSeleccionado) {
      this.estadosSeleccionados.push(idEsado);
      this.estadosSeleccionados.forEach(e => {
        this.estados.forEach(es => {
          estaSeleccionado = false;
          this.estadosSeleccionadosNombres.forEach(esn => {
            if (es.nombre == esn.nombre) {
              estaSeleccionado = true;
            }
          })
          if (es.idEstado == e && !estaSeleccionado) {
            this.estadosSeleccionadosNombres.push(es);
          }
        })
      })
    }
  }

  quitarEstado(idEstado) {
    let count = 0;
    for (count; count < this.estadosSeleccionadosNombres.length; count++) {
      if (this.estadosSeleccionadosNombres[count].idEstado == idEstado)
        break
    }
    this.estadosSeleccionadosNombres.splice(count, 1);
    this.estadosSeleccionados.splice(count, 1);
    if (this.estadosSeleccionados.length < 1)
      this.estadosSeleccionados = [0];
  }

  diferenteDeCero(elemento) {
    return elemento != 0;
  }

  asignarData(data: any) {
    this.crearPaginas(data.totalPages);
    this.paginador = data;
    this.contactos = data.content;
    this.contactosFiltrados = [...this.contactos];

    this.totalFilas = data.totalElements;
    this.opcionesFilas = Array.from({ length: this.totalFilas }, (_, i) => i + 1);

    this.desdeFila = data.number * data.size + 1;
    this.hastaFila = this.desdeFila + data.numberOfElements - 1;

    this.mostrarSpinner = false;
    this.mostrarSinResultados = data.totalElements === 0;
  }

  mostrarCobertura(idCobertura): string {
    let estado: Estado = null;
    this.estados.forEach(est => {
      if (est.idEstado == idCobertura) {
        estado = est;
      }
    });
    return estado.nombre;
  }

  listarEstadosSeleccionado(event: any) {
    this.estadoSeleccionado = parseInt(event.target.value);
  }

  buscarPorEstado() {
    this.mostrarEmptyState = false;
    this.mostrarSpinner = true;
    // Si el valor es 0, buscar todos los estados
    if (this.estadoSeleccionado === 0) {
      this.requestDirectorio.page = 0;
      this.requestDirectorio.estados = [0];
      this.cambiarDePagina(this.requestDirectorio);
    } else {
      // Filtrar por estado específico
      this.requestDirectorio.estados = [this.estadoSeleccionado];
      this.requestDirectorio.page = 0;
      this.cambiarDePagina(this.requestDirectorio);
      this.contactosFiltrados = this.contactos.filter(c => c.idestado === this.estadoSeleccionado);
      this.totalFilas = this.contactosFiltrados.length;
      //this.mostrarSinResultados = this.contactosFiltrados.length === 0;
    }
    console.log(`Filtrado por estado ID: ${this.estadoSeleccionado}`);
  
    console.log(`Resultados encontrados: ${this.contactosFiltrados.length}`);
  }

  modalInstance: any;
  abrirModal(contacto: any) {
    const modalElement = document.getElementById('contactoModal');
    this.modalInstance = new Modal(modalElement);
    this.modalInstance.show();
    this.contacto = contacto;
    this.idG = contacto;
  }

  // Método unificado para enviar formulario
  enviarFormulario(): void {
    if (this.formSolicitudGen.invalid) {
      // Marcar todos los campos como tocados para mostrar errores
      Object.keys(this.formSolicitudGen.controls).forEach(key => {
        this.formSolicitudGen.get(key)?.markAsTouched();
      });

      Swal.fire({
        icon: "error",
        title: "Formulario incompleto",
        text: "Por favor llena todos los campos requeridos correctamente.",
        confirmButtonText: 'Aceptar',
        confirmButtonColor: '#eb0029'
      });
      return;
    }

    if (this.enviado) return;
    this.enviado = true;

    const valoresFormulario = this.formSolicitudGen.value;

    // Determinar si es solicitud de gerente o contacto general
    if (this.idG && this.idG > 0) {
      // Es solicitud para gerente específico
      this.enviarSolicitudGerente(valoresFormulario);
    } else {
      // Es contacto general
      this.enviarContactoGeneral(valoresFormulario);
    }
  }

ordenarPor(campo: string): void {
  if (this.campoOrden === campo) {
    this.ordenAscendente = !this.ordenAscendente;
  } else {
    this.campoOrden = campo;
    this.ordenAscendente = true;
  }

  this.contactosFiltrados.sort((a, b) => {
    const valorA = (a[campo] || '').toString().toLowerCase();
    const valorB = (b[campo] || '').toString().toLowerCase();

    return this.ordenAscendente
      ? valorA.localeCompare(valorB, 'es', { sensitivity: 'base' })
      : valorB.localeCompare(valorA, 'es', { sensitivity: 'base' });
  });
}


  cambiarFilasPorPagina() {
    this.requestDirectorio.page = 0;
    this.cambiarDePagina(this.requestDirectorio);
  }

 soloNumeros(event: KeyboardEvent): void {
   const key = event.key;
   if (!/^\d$/.test(key) && key !== 'Backspace' && key !== 'Tab' &&
     key !== 'ArrowLeft' && key !== 'ArrowRight' && key !== 'Delete') {
     event.preventDefault();
   }
 }

 soloLetras(event: KeyboardEvent): void {
    const key = event.key;

    const regex = /^[a-zA-ZáéíóúÁÉÍÓÚñÑ\s]$/;

    if (!regex.test(key) &&
        key !== 'Backspace' &&
        key !== 'Tab' &&
        key !== 'ArrowLeft' &&
        key !== 'ArrowRight' &&
        key !== 'Delete') {
      event.preventDefault();
    }
  }

  openModalExitoso(): void {
    const dialogRef = this.dialog.open(OpExitosaModalComponent, {
      panelClass: 'modal-exitoso',
      autoFocus: false,
      disableClose: true
    });

    document.body.classList.add('disable-scroll');

    dialogRef.afterClosed().subscribe(() => {
      document.body.classList.remove('disable-scroll');
    });
  }

  guardarGerentes() {
    if (!this.formSolicitudGen.valid) {
      Swal.fire({
        icon: "error",
        title: "Información Incompleta...",
        text: "Debe registrar todos los campos requeridos..!",
        confirmButtonText: 'Aceptar',
        confirmButtonColor: '#eb0029'
      });
      return;
    }
    // prevenir doble envío
    if (this.enviado) {
      return;
    }
    this.enviado = true;
    const f = this.formSolicitudGen!;
    console.log('Busco entra:', this.formSolicitudGen.get('buscoinformacion')?.value);
    console.log('Folio:', this.formSolicitudGen.get('folio')?.value);
    console.log('Nombre:', this.formSolicitudGen.get('nombre')?.value);
    console.log('Correo:', this.formSolicitudGen.get('correo')?.value);
    console.log('Teléfono Celular:', this.formSolicitudGen.get('telefonocelular')?.value);
    console.log('Teléfono Fijo:', this.formSolicitudGen.get('telefonofijo')?.value);
    console.log('Mensaje:', this.formSolicitudGen.get('mensaje')?.value);
    console.log('Correoc:', this.formSolicitudGen.get('correoc')?.value);
    console.log('Telefono:', this.formSolicitudGen.get('telefono')?.value);
    console.log('Todos:', this.formSolicitudGen.get('todos')?.value);
    this.payLoadOportunidad = {
      idgerente: this.idG,
      correo: f.get('correo')!.value,
      buscoinformacion: f.get('buscoinformacion')!.value,
      mensaje: f.get('mensaje')!.value,
      nombre: f.get('nombre')!.value,
      apellido1: f.get('paterno')!.value,
      apellido2: f.get('materno')!.value,
      telefonocelular: f.get('telefonocelular')!.value,
      telefonofijo: f.get('telefonofijo')!.value,
      folio: f.get('folio')!.value,
      correoc: false,
      celular: false,
      todos: false
    };

    if (this.formSolicitudGen.get('todos')?.value === 'ambos') {
      console.log('Aquí paso Juan:', this.formSolicitudGen.get('todos')?.value);
      this.payLoadOportunidad.todos = true;
    }

    if (this.formSolicitudGen.get('todos')?.value === 'telefono') {
      console.log('Aquí paso Andy:', this.formSolicitudGen.get('todos')?.value);
      this.payLoadOportunidad.celular = true;
    }

    if (this.formSolicitudGen.get('todos')?.value === 'correoc') {
      console.log('Aquí paso Adolfo:', this.formSolicitudGen.get('todos')?.value);
      this.payLoadOportunidad.correoc = true;

    }
    console.log('Payload Gerente:', this.payLoadOportunidad);
    this.directorioService.guardarNuevaSolicitud(this.payLoadOportunidad).subscribe({
      next: (data: SolicitudGerente) => {
        if (data.mensaje === this.OK) {
          this.openModalExitoso();
          this.formSolicitudGen.reset({
            buscoinformacion: '',
            folio: '',
            nombre: '',
            paterno: '',
            materno: '',
            correo: '',
            telefonocelular: '',
            telefonofijo: '',
            mensaje: '',
            todos: ''
          });
          this.selectedInformacionText = '';
          this.modalInstance?.hide();
          this.enviado = false;
        } else {
          this.enviado = false;
          console.log("Error: no OK");
        }
      },
      error: (error) => {
        this.enviado = false;
        console.error(error);
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Algo salió mal!",
          confirmButtonText: 'Aceptar',
          confirmButtonColor: '#eb0029'
        });
      }
    });
  }

  informacionRotation: number = 0;
  openedSelect: string = '';
  estadoRotation: number = 0;
  selectedEstadoNombre: string = 'Todos';
  selectedInformacionText: string = '';

  @HostListener('document:click', ['$event'])
  onClickOutside(event: MouseEvent) {
    const target = event.target as HTMLElement;
    const isInside = target.closest('.custom-select-wrapper');
    if (!isInside && this.openedSelect === 'estado') {
      this.openedSelect = '';
      this.estadoRotation -= 180;
    }
    if (!isInside && this.openedSelect === 'buscoinformacion') {
      this.openedSelect = '';
      this.informacionRotation -= 180;
    }
  }

  selectEstadoDirectorio(id: number, nombre: string) {
    this.estadoSeleccionado = id;
    this.selectedEstadoNombre = nombre;
    this.listarEstadosSeleccionado({ target: { value: id } });
    this.toggleEstado();
  }

  selectInformacionD(valor: string, texto: string) {
   this.selectedInformacionText = texto;
   this.formSolicitudGen.get('buscoinformacion')?.setValue(valor);
   this.toggleSelect('buscoinformacion');
 }

  toggleSelect(campo: string) {
    const wasOpen = this.openedSelect === campo;
    const prev = this.openedSelect;

    if (wasOpen) {
      this.openedSelect = '';
      if (campo === 'buscoinformacion') {
        this.informacionRotation -= 180;
      }
    } else {
      this.openedSelect = campo;
      if (campo === 'buscoinformacion') {
        this.informacionRotation -= 180;
      }
      if (prev && prev !== campo) {
        this.updateRotation(prev);
      }
    }
  }

  toggleEstado() {
    const wasOpen = this.openedSelect === 'estado';
    const prev = this.openedSelect;

    this.openedSelect = wasOpen ? '' : 'estado';
    this.estadoRotation -= 180;

    // Cierra cualquier otro abierto y completa rotación
    if (!wasOpen && prev && prev !== 'estado') {
      this.updateRotation(prev);
    }
  }

  updateRotation(field: string) {
    switch (field) {
      case 'buscoinformacion':
        this.informacionRotation -= 180;
        break;
     case 'estado':
       this.estadoRotation -= 180;
       break;
   }
 }
  public capitalizeFirstLetter = (texto: string): string => {
  if (!texto) return '';
  return texto
    .toLowerCase()
    .split(' ')
    .map(palabra => palabra.charAt(0).toUpperCase() + palabra.slice(1))
    .join(' ');
}
isReadonly = true;
disableReadonly(event: FocusEvent): void {
 const input = event.target as HTMLInputElement;
 input.removeAttribute('readonly');
 this.isReadonly = false;
}
limpiarForm() {
    this.formSolicitudGen.reset({
      buscoinformacion: [''],
      folio: [''],
      contacto: '',
      nombre: '',
      apaterno: '',
      materno: '',
      correo: '',
      telefonocelular: '',
      telefonofijo: '',
      mensaje: ''
    });
    this.selectedEstadoText = '';
    this.selectedInformacionText = '';
  }
}